var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 10.625L15.1406 1.10938C14.7656 0.78125 14.0156 0.546875 13.5 0.546875C12.9375 0.546875 12.1875 0.78125 11.8125 1.10938L0.234375 10.625C0.09375 10.7656 0 11 0 11.1875C0 11.3281 0.046875 11.5625 0.140625 11.6562L0.65625 12.2656C0.75 12.4062 1.03125 12.5 1.21875 12.5C1.35938 12.5 1.59375 12.4531 1.6875 12.3594L3 11.2812V20C3 20.8438 3.65625 21.5 4.5 21.5H10.5C11.2969 21.5 11.9531 20.8438 12 20V15.125H15V20C15 20.8438 15.6562 21.5 16.5 21.5H22.5C23.2969 21.5 23.9531 20.8438 24 20.0469V11.2812L25.2656 12.3594C25.3594 12.4531 25.5938 12.5469 25.7344 12.5469C25.9219 12.5469 26.2031 12.4062 26.3438 12.2656L26.8125 11.6562C26.9062 11.5625 27 11.3281 27 11.1875C27 11 26.8594 10.7656 26.7188 10.625ZM21.7031 19.25H17.25V14.375C17.2031 13.5781 16.5469 12.9219 15.75 12.875H11.25C10.4062 12.9219 9.75 13.5781 9.75 14.375V19.25H5.25V9.45312L13.5 2.65625L21.75 9.45312L21.7031 19.25Z",
    fill: "#93A2BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ae0ead72.svg";
export { ForwardRef as ReactComponent };